import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { priceImprovementBlotterDetailClosedThunk } from 'state/blotters/priceImprovement/priceImprovementBlotter.thunk';
import type { PriceImprovementStatus } from 'state/quotes/priceEnhancements/priceImprovementRequest/priceImprovementRequest.model';
import { priceImprovementBlotter } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

interface StateProps {
  id: string;
  quoteId: string;
  status: PriceImprovementStatus;
}

interface DispatchProps {
  onClosed: () => void;
}

export type PriceImprovementBlotterPanelProps = StateProps & DispatchProps;

const mapStateToProps: MapStateToProps<StateProps, {}, AppState> = (state: AppState): StateProps => {
  const { id, quoteId, status } = priceImprovementBlotter.getDetailItem(state)!;
  return { id, quoteId, status: status as PriceImprovementStatus };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => {
  return {
    onClosed() {
      dispatch(priceImprovementBlotterDetailClosedThunk());
    },
  };
};

export const connectPriceImprovementBlotterPanel = connect(mapStateToProps, mapDispatchToProps);
